import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import { STBAttachments } from '../../../api';
import './STBAttachments.css';

interface STBAttachmentsProp {
    stbAttachment: STBAttachments;
}

const STBAttachmentsSection: React.FC<STBAttachmentsProp> = (props) => {

    return (
        <Container className='align-items-center tablecolor mb-4'>
            <Row>
                <Col xs={12} md={6} lg={12}>
                    <div className='header-section-5-input mt-3 mb-3'>
                        <h3 className='mb-5'>6. Bilagor</h3>
                        <h3 className='mb-4'>Följande handligar hör till planen:</h3>
                    </div>
                    <Col xs={12}>
                        <div className='checkboxAndLabel'>
                            <input type='checkbox' defaultChecked={props.stbAttachment.generalAssemblyInstructionCheck}
                                onChange={() => {
                                    if (props.stbAttachment.generalAssemblyInstructionCheck === false) {
                                        props.stbAttachment.generalAssemblyInstructionCheck = true;
                                    }
                                    else if (props.stbAttachment.generalAssemblyInstructionCheck === true) {
                                        props.stbAttachment.generalAssemblyInstructionCheck = false;
                                    }
                                }}
                            />
                            <span className='labelText'>
                                <LabelAndTextBox
                                    title='Generell monteringsinstruktion'
                                    remark={props.stbAttachment?.generalAssemblyInstruction}
                                    onChange={(value) => {
                                        props.stbAttachment.generalAssemblyInstruction = value;
                                    }}
                                />
                            </span>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className='checkboxAndLabel'>
                            <input type='checkbox' defaultChecked={props.stbAttachment.specialAssemblyInstructionCheck}
                                onChange={() => {
                                    if (props.stbAttachment.specialAssemblyInstructionCheck === false) {
                                        props.stbAttachment.specialAssemblyInstructionCheck = true;
                                    }
                                    else if (props.stbAttachment.specialAssemblyInstructionCheck === true) {
                                        props.stbAttachment.specialAssemblyInstructionCheck = false;
                                    }
                                }} />
                            <span className='labelText'>
                                <LabelAndTextBox title='Särskild monteringsinstruktion' remark={props.stbAttachment?.specialAssemblyInstruction}
                                    onChange={(value) => {
                                        props.stbAttachment.specialAssemblyInstruction = value;
                                    }} />
                            </span>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className='checkboxAndLabel'>
                            <input type='checkbox' defaultChecked={props.stbAttachment.typeControlCertificateCheck}
                                onChange={() => {
                                    if (props.stbAttachment.typeControlCertificateCheck === false) {
                                        props.stbAttachment.typeControlCertificateCheck = true;
                                    }
                                    else if (props.stbAttachment.typeControlCertificateCheck === true) {
                                        props.stbAttachment.typeControlCertificateCheck = false;
                                    }
                                }} />
                            <span className='labelText'>
                                <LabelAndTextBox title='Typkontrollintyg (ange nummer)' remark={props.stbAttachment?.typeControlCertificate}
                                    onChange={(value) => {
                                        props.stbAttachment.typeControlCertificate = value;
                                    }}
                                />
                            </span>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className='checkboxAndLabel'>
                            <input type='checkbox' defaultChecked={props.stbAttachment.dimensionManagementCheck}
                                onChange={() => {
                                    if (props.stbAttachment.dimensionManagementCheck === false) {
                                        props.stbAttachment.dimensionManagementCheck = true;
                                    }
                                    else if (props.stbAttachment.dimensionManagementCheck === true) {
                                        props.stbAttachment.dimensionManagementCheck = false;
                                    }
                                }} />
                            <span className='labelText'>
                                <LabelAndTextBox title='Dimensionshandling (beteckning)' remark={props.stbAttachment?.dimensionManagement}
                                    onChange={(value) => {
                                        props.stbAttachment.dimensionManagement = value;
                                    }} />
                            </span>
                        </div>
                    </Col>
                    <Col xs={12}>
                        <div className='checkboxAndLabel'>
                            <input type='checkbox' defaultChecked={props.stbAttachment.otherManagementCheck}
                                onChange={() => {
                                    if (props.stbAttachment.otherManagementCheck === false) {
                                        props.stbAttachment.otherManagementCheck = true;
                                    }
                                    else if (props.stbAttachment.otherManagementCheck === true) {
                                        props.stbAttachment.otherManagementCheck = false;
                                    }
                                }} />
                            <span className='labelText'>
                                <LabelAndTextBox title='Annan handling (beteckning)' remark={props.stbAttachment?.otherManagement}
                                    onChange={(value) => {
                                        props.stbAttachment.otherManagement = value;
                                    }} />
                            </span>
                        </div>
                    </Col>
                </Col>
            </Row>
            <hr />
        </Container>
    );
};

export default STBAttachmentsSection;